import PropTypes from 'prop-types';
import farePropType from './fare';

export default PropTypes.arrayOf(farePropType);
